import { render, staticRenderFns } from "./user-accesses.vue?vue&type=template&id=65f84d12&"
import script from "./user-accesses.vue?vue&type=script&lang=js&"
export * from "./user-accesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports